import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { OrdersService } from 'src/app/feature/order/Service/order.service';

import { Constants } from '../constants';
import { LoaderService } from '../loader/loader.service';
import { BroadcastService } from '../services/broadcast.service';
import { NotificationService } from '../services/notification-service';

@Component({
    selector: 'app-edit-specimen-kit',
    templateUrl: './edit-specimen-kit.component.html',
    styleUrls: ['./edit-specimen-kit.component.scss'],
    standalone: false
})
export class EditSpecimenKitComponent implements OnInit, AfterViewChecked {

  dialog: UntypedFormGroup;
  @Output() redirectEvent = new EventEmitter();
  specimenKitId = '';
  kitId: string;
  regexForKitIdFormat = Constants.KITID_FORMAT;
  kitIdLength = 12;
  kitIdExists = false;
  refreshOrderPage = false;
  public kitIdLengthError = false;
  kitIdFormatIncorrect = false;
  public maxLengthKit = 12;
  public hyphenPositions = [];
  ValidationMessages = {
    MINIMUM_KIT_ID_LENGTH: 'Kit ID must be characters long',
    INCORRECT_KIT_ID_FORMAT: 'Kit ID format is incorrect',
    KITID_MANDATORY: 'Kit ID is mandatory',
    KITDEXISTS: 'The Kit ID already exists. Please enter a new one.'
  };
  selectedKitIdFormat = '';

  constructor(
    public dialogRef: MatDialogRef<EditSpecimenKitComponent>,
    public broadcastService: BroadcastService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly snackbarService: NotificationService,
    private readonly orderService: OrdersService,
    @Inject(MAT_DIALOG_DATA) private readonly data,
    private readonly loader: LoaderService,
    private readonly auth: AuthenticationService,
    private readonly cdr: ChangeDetectorRef) {
    }

  ngOnInit() {
    this.dialog = this.formBuilder.group({
      SpecimenKitId: ['', [Validators.required]],
    });
    this.dialog.get('SpecimenKitId').setValue(this.data.specimenKitId);
    this.kitId = this.data.specimenKitId;
    this.kitIdExists = false;
    this.getKitIdFormat();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  public async getKitIdFormat() {
    this.loader.show();
    this.orderService.TestMapService(this.data).subscribe({
      next: (res) => {
        if (res) {
          this.data.kitIdFormat = res.kitIdFormat;
          this.checkKitIdFormatValidation();
          this.loader.hide();
        }
        this.loader.hide();
      },
      error: (error: HttpErrorResponse) => {
        this.loader.hide();
        if (error.status === 400) {
          this.kitIdFormatIncorrect = true;
          this.snackbarService.dismissSnackbar();
        }
      }
    });
  }

  public checkKitIdFormatValidation() {
    if (this.data.kitIdFormat && this.data.kitIdFormat !== '') {
      const kitIdFormats = this.data.kitIdFormat.replace(/\s+/g, '').split(',');
      this.selectedKitIdFormat = kitIdFormats[0];
      this.dialog.controls.SpecimenKitId.clearValidators();
      this.dialog.controls.SpecimenKitId.setValidators([Validators.required,
      Validators.minLength(this.selectedKitIdFormat.length), Validators.maxLength(this.selectedKitIdFormat.length)]);
      this.maxLengthKit = this.selectedKitIdFormat.length;
      this.ValidationMessages.MINIMUM_KIT_ID_LENGTH = `Kit ID must be ${  this.countKitIdLength()  } characters long`;
      this.dialog.controls.SpecimenKitId.updateValueAndValidity();
      this.hyphenPositions = this.getHyphenPosition();
    }
  }
  private getHyphenPosition() {
    let flag = 0;
    const indices = [];
    for (let i = 0; i < this.selectedKitIdFormat.length; i++) {
      if (this.selectedKitIdFormat[i] === '-') {
        if (flag === 0) {
          indices.push(i);
          flag++;
        } else {
          indices.push(i);
        }
      }
    }

    return indices;
  }

  private countKitIdLength() {
    return this.selectedKitIdFormat.length - (this.selectedKitIdFormat.split('-').length - 1);
  }

  CloseDialog() {
    this.dialogRef.close(null);
  }

  Save() {
    this.kitIdExists = false;
    this.specimenKitId = this.dialog.get('SpecimenKitId').value;
    const oldValue = this.data.specimenKitId;
    this.data.specimenKitId = this.specimenKitId;
    this.loader.show();
    this.orderService.editSpecimenKitId(this.data).subscribe({
      next: (data: { IsSuccess: boolean, message: string }) => {
        if (data.IsSuccess) {
          this.data.specimenKitId = this.specimenKitId;
        }
        this.loader.hide();
        this.broadcastService.broadcast(Constants.REFRESH_ORDERS);
        this.broadcastService.broadcast(Constants.REFRESH_ORDER_RESULTS_LIST);
        this.snackbarService.success(data.message);
        this.dialogRef.close({ old: oldValue, new: this.specimenKitId });
      },
      error: (error: HttpErrorResponse) => {
        this.loader.hide();
        if (error.status === 400) {
          this.kitIdExists = true;
          this.data.specimenKitId = this.kitId;
          this.snackbarService.dismissSnackbar();
        }
      }
    });
  }


  public isDisabled() {
    let disableSave = true;
    const formInvalid = !this.dialog.dirty || this.dialog.invalid;
    if (!formInvalid && !this.kitIdFormatIncorrect) {
      disableSave = false;
    }
    return disableSave;
  }

  public verifyKitIdRegex() {
    this.kitIdExists = false;
    if (this.selectedKitIdFormat !== null && this.dialog.controls.SpecimenKitId.value !== null) {
      // First check if the length of the user entered kit id foramt is same or not with the first kit id format provided in
      // TestMap table of EventContext
      if (this.selectedKitIdFormat.length === this.dialog.controls.SpecimenKitId.value.length) {
        this.checkKitIdFormat(this.selectedKitIdFormat);
      }
    }
  }

  private isCharValid(kitChar: string, enteredChar: string): boolean {
    if (kitChar === '@') {
      return !!/[a-zA-Z\d]/.exec(enteredChar);
    } else if (kitChar === '#') {
      return !!/\d/.exec(enteredChar);
    } else if (kitChar === '-') {
      return enteredChar === '-';
    } else if (/\d/.exec(kitChar)) {
      return kitChar === enteredChar;
    } else if (/[a-zA-Z]/.exec(kitChar)) {
      return kitChar.toLowerCase() === enteredChar.toLowerCase();
    }
    return kitChar === enteredChar;
  }

  private checkKitIdFormat(selectedKitIdFormat: string) {
    let count = 0;
    const enteredValueArray: any[] = Array.from(this.dialog.controls.SpecimenKitId.value);
    const kitIdArray = Array.from(selectedKitIdFormat);
    for (let i = 0; i < kitIdArray.length; i++) {
      if (!this.isCharValid(kitIdArray[i], enteredValueArray[i])) {
        count++;
      }
    }
    this.kitIdFormatIncorrect = count !== 0;
  }
}
